// Utility to estimate luggage capacity from bootspace in liters
// Returns an object with estimated counts for large, medium, and cabin suitcases

export function estimateLuggageFromLiters(liters) {
  if (!liters || typeof liters !== 'number' || liters <= 0) {
    return { large: 0, medium: 0, cabin: 0 };
  }
  const large = Math.floor(liters / 220);
  const medium = Math.floor((liters % 220) / 90);
  const cabin = Math.floor(((liters % 220) % 90) / 40);
  return { large, medium, cabin };
}

// Example:
// estimateLuggageFromLiters(400) => { large: 4, medium: 0, cabin: 0 }
// estimateLuggageFromLiters(250) => { large: 2, medium: 1, cabin: 1 }
